module.exports = __webpack_public_path__ + "img/image-user.11c4292d.svg";